import React from "react";
import { InputAdornment, TextField, IconButton, Tooltip, useTheme, TextFieldProps, Stack, Button } from "@mui/material";
import { Call02Icon, MultiplicationSignIcon, Search01Icon, UserAdd01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import InputMask from "react-input-mask";
import { sanitizePhone } from "@/utils/phones";
import { useAppDispatch } from "@/hooks";
import { openNewClientFormDrawer } from "@/store/uiSlice";
import LoadingButton from "@mui/lab/LoadingButton";

interface CustomerPhoneSearchFieldProps extends Omit<TextFieldProps, "onChange"> {
  value: string;
  label?: string;
  size?: "small" | "medium" | "large";
  isLoading?: boolean;
  onChange: (value: string) => void;
  onClear?: () => void;
  onSearch?: () => void;
}

const CustomerPhoneSearchField: React.FC<CustomerPhoneSearchFieldProps> = ({
  value,
  label = "Teléfono",
  size = "medium",
  isLoading,
  onClear,
  onSearch,
  onChange,
  ...props
}) => {
  const { palette } = useTheme();
  const dispatch = useAppDispatch();

  const onRegister = () => {
    dispatch(openNewClientFormDrawer());
  }

  return (
    <Stack direction={{ lg: 'row' }} gap={2} alignItems="stretch">
      <InputMask
        mask="9999-9999"
        placeholder="0000-0000"
        alwaysShowMask={false}
        value={value}
        onChange={(e) => onChange(sanitizePhone(e.target.value))}
        onBlur={props.onBlur}
        size={size}
      >
        {() => (
          <TextField
            {...props}
            fullWidth
            label={label}
            size={size}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <HugeiconsIcon icon={Call02Icon} color={palette.primary.main} />
                  </InputAdornment>
                ),
                endAdornment: value ? (
                  <InputAdornment position="end">
                    {onClear && (
                      <Tooltip title="Limpiar búsqueda" placement="top" arrow>
                        <IconButton onClick={onClear} size="small">
                          <HugeiconsIcon icon={MultiplicationSignIcon} color={palette.primary.main} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </InputAdornment>
                ) : null,
              },
            }}
          />
        )}
      </InputMask>
      <Stack direction="row" gap={2}>
        <LoadingButton
          size={size}
          onClick={onSearch}
          variant="contained"
          loading={isLoading}
          sx={{ px: size === 'large' ? 6 : 4 }}
          startIcon={<HugeiconsIcon icon={Search01Icon} />}
          fullWidth
        >
          Buscar
        </LoadingButton>
        <Button
          variant="outlined"
          size={size} sx={{ px: size === 'large' ? 6 : 4 }}
          startIcon={<HugeiconsIcon icon={UserAdd01Icon} />}
          onClick={onRegister}
          fullWidth
        >
          Registrar
        </Button>
      </Stack>
    </Stack>
  );
};

export default CustomerPhoneSearchField;
